import { c as _c } from "react/compiler-runtime";
import { Details, Summary } from '@/components/Atoms/Details/Details';
import { Hidden } from '@/components/Atoms/Hidden/Hidden';
import { CenteredPageContent } from '@/components/Layouts/CenteredPageContent';
import { AccountMenuList } from '@/components/Organisms/Navigation/AccountMenu/AccountMenuList';
import { NavPanelContent, panelContentStyles } from '@/components/Organisms/Navigation/Menu/NavPanelContent';
import { useNavigationContext } from '@/contexts/NavigationContext/NavigationContext';
import { ACCOUNT_MENU_ID, MENU_ID, getNavSectionId } from '@/contexts/NavigationContext/NavigationWrapper';
import useTranslation from '@/hooks/useTranslation';
import { breakpoints } from '@/styles/media';
import type { FC, HTMLAttributes } from 'react';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
export const NavMenu = () => {
  const $ = _c(11);
  const {
    navSections
  } = useNavigationContext();
  const {
    t
  } = useTranslation("common");
  if (!navSections) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <></>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] !== t) {
    t0 = t("Navigation.menu");
    $[1] = t;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== t0) {
    t1 = <Hidden as="h2">{t0}</Hidden>;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== navSections) {
    t2 = navSections.map(_temp);
    $[5] = navSections;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <AccountSection />;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t2) {
    t4 = <Nav id={MENU_ID}>{t1}{t2}{t3}</Nav>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
const Nav = styled.nav`
    display: block;
    background: var(--cds-color-background);
`;
const AccountSection = () => {
  const $ = _c(7);
  const {
    t
  } = useTranslation("common");
  const [hasActivated, setHasActivated] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setHasActivated(true);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  if (hasActivated) {
    return null;
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("Common.account");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <AccountSectionContent><AccountMenuList /></AccountSectionContent>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <NavSection id={ACCOUNT_MENU_ID} title={t2}>{t3}</NavSection>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
const NavSection: FC<{
  title: string;
} & HTMLAttributes<HTMLDivElement>> = t0 => {
  const $ = _c(13);
  let children;
  let rest;
  let title;
  if ($[0] !== t0) {
    ({
      children,
      title,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = rest;
    $[3] = title;
  } else {
    children = $[1];
    rest = $[2];
    title = $[3];
  }
  const {
    isMenuOpen
  } = useNavigationContext();
  const t1 = isMenuOpen === undefined;
  let t2;
  if ($[4] !== title) {
    t2 = <SectionTitle>{title}</SectionTitle>;
    $[4] = title;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== children || $[7] !== t1 || $[8] !== t2) {
    t3 = <Details open={t1}>{t2}{children}</Details>;
    $[6] = children;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== rest || $[11] !== t3) {
    t4 = <NavSectionWrap {...rest}>{t3}</NavSectionWrap>;
    $[10] = rest;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
const NavSectionWrap = styled.div`
    ${breakpoints.L`
        display: none;
        margin-bottom: 90vh;
    `}
    &:target {
        display: block;
    }
`;
const SectionTitle = styled(Summary)`
    padding: var(--size-grid-half) var(--size-grid-unit);
    border-bottom: solid 1px var(--color-lines-subtleDivider);
`;
const AccountSectionContent = styled(CenteredPageContent)`
    ${panelContentStyles};
`;
function _temp(section, i) {
  return <NavSection id={getNavSectionId(i)} key={i} title={section.title}><NavPanelContent section={section} /></NavSection>;
}